module.exports = __webpack_public_path__ + "static/media/avis.6a48d8f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/work/avis.jpg
// module id = 108
// module chunks = 0